import React, {useEffect} from "react";
import '../style/global.css';
import Navigation from "../components/Navigation";
import Floating from "../components/Floating";
import Footer from "../components/Footer";
import {useLocation} from "react-router-dom";

type StyledPageProps = {
  children: React.ReactNode;
};

const StyledPage: React.FC<StyledPageProps> = ({children}) => {
  const location = useLocation();
  useEffect(() => {
    const updateViewportHeight = () => {
      const vh = window.innerHeight * 0.01;
      document.documentElement.style.setProperty("--vh", `${vh}px`);
    };

    updateViewportHeight();
    window.addEventListener("resize", updateViewportHeight);

    return () => {
      window.removeEventListener("resize", updateViewportHeight);
    };
  }, []);
  return (
    <div className="styled-page-container">
      <Floating/>
      <div className={'styled-page-content'}>
        {children}
        {location.pathname !== '/admin' && (
          <Footer/>
        )}
      </div>
      <Navigation/>
    </div>
  );
};

export default StyledPage;
